
namespace RioERP.Masters {

    @Serenity.Decorators.registerClass()
    export class EmailTemplatesGrid extends Serenity.EntityGrid<EmailTemplatesRow, any> {
        protected getColumnsKey() { return EmailTemplatesColumns.columnsKey; }
        protected getDialogType() { return EmailTemplatesDialog; }
        protected getIdProperty() { return EmailTemplatesRow.idProperty; }
        protected getInsertPermission() { return EmailTemplatesRow.insertPermission; }
        protected getLocalTextPrefix() { return EmailTemplatesRow.localTextPrefix; }
        protected getService() { return EmailTemplatesService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}